import clsx from "clsx";
import { labelStyle, inputStyle } from "../index";

export default function AuthorDateURI({
  uri,
  onUri,
  date,
  onDate,
  author,
  onAuthor,
}) {
  return (
    <>
      <div className={containerStyle}>
        <div className="flex items-center w-1/3">
          <div className={labelStyle}>Author</div>
          <input
            className={inputStyle}
            type="title"
            value={author}
            placeholder={author || "Author Name"}
            onChange={(e) => onAuthor(e.target.value)}
          />
        </div>
        <div className="flex items-center w-[200px] mx-4">
          <div className={labelStyle}>Date</div>
          <input
            className={clsx(inputStyle + " w-full")}
            type="date"
            value={date}
            onChange={(e) => onDate(e.target.value)}
          />
        </div>
        <div className="flex items-center w-1/2">
          <label className={labelStyle}>URI</label>
          <input
            required
            className={inputStyle}
            value={"/" + uri}
            onChange={onUri}
          />
        </div>
      </div>
    </>
  );
}

const containerStyle = clsx("w-full flex justify-between items-center mt-4");
